// extracted by mini-css-extract-plugin
export default {"productCarousel":"w0-z"};